export const weightMixin = {
  data() {
    return {
      selectedWeightRange: "kg"
    };
  },

  methods: {
    range(from, to, step) {
      return Array(~~((to - from) / step) + 1) // '~~' is Alternative for Math.floor()
        .fill()
        .map((v, i) => from + i * step);
    }
  },

  computed: {
    weightRange() {
      return this.selectedWeightRange == "kg"
        ? this.range(100, 900, 100)
        : this.range(15, 120, 15);
    }
  }
};
